import { configureStore } from '@reduxjs/toolkit';
import { productsApi } from '../features/products/productsApi.ts';
import { categoryApi } from '../features/admin/categoryApi.ts';
import { unitApi } from '../features/admin/unitApi.ts';
import themeReducer from '../features/themeSlice.ts';
import { deliveryApi } from '../features/admin/deliveryApi.ts';
import { subCategoryApi } from '../features/admin/subcategoryApi.ts';
import { shippingApi } from '../features/admin/shippingApi.ts';
import { productApi } from '../features/admin/productApi.ts';
import { orderApi } from '../features/admin/OrderlistApi.ts';
import { reviewApi } from '../features/admin/reviewApi.ts';
import { creditSalesApi } from '../features/admin/setCreditApi.ts';
import { guestOrderApi } from '../features/admin/guestOrderlist.ts';
import { guestUserOrderApi } from '../features/admin/guestUserOrderApi.ts';
import { userListApi } from '../features/admin/userlistApi.ts';
import { flashSaleApi } from '../features/admin/flashSaleApi.ts';
import { bannerApi } from '../features/admin/bannerApi.ts';
import { subBannerApi } from '../features/admin/subBanner.ts';
import { dealOfTheDayApi } from '../features/admin/dealoftheday.ts';
import { bundleApi } from '../features/admin/bundleApi.ts';
import authReducer from '../features/admin/authSlice.ts'; // Import the auth slice
import { deliveryAgentApi } from '../features/admin/deliveryAgent.ts';
import { warehouseApi } from '../features/admin/warehouseApi.ts';
import { warrantyApi } from '../features/admin/warrantyApi.ts';
import { productWarehouseApi } from '../features/admin/productWarehouseApi.ts';
import { couponApi } from '../features/admin/couponApi.ts';
import { rewardApi } from '../features/admin/rewardApi.ts';
import { rewardSettingsApi } from '../features/admin/rewardSettingsApi.ts';
import { adminRewardsApi } from '../features/admin/adminRewardsApi.ts';
import { adminCouponUsersApi } from '../features/admin/adminCouponUsersApi.ts';
import { dashboardApi } from '../features/admin/dashboardApi.ts';
import { smtpSettingsApi } from '../features/admin/smtpSettingsApi.ts';
import { deliverySettingsApi } from '../features/admin/deliverySettingsApi.ts';
import { registerAdminApi } from '../features/admin/registerAdmin.ts';
import { roleMasterApi } from '../features/admin/roleMasterApi.ts';
import { roleMappingApi } from '../features/admin/roleMapping.ts';

export const store = configureStore({
  reducer: {
    // Add auth reducer
    auth: authReducer,
    theme: themeReducer,
    [productsApi.reducerPath]: productsApi.reducer,
    [categoryApi.reducerPath]: categoryApi.reducer,
    [subCategoryApi.reducerPath]: subCategoryApi.reducer,
    [unitApi.reducerPath]: unitApi.reducer,
    [deliveryApi.reducerPath]: deliveryApi.reducer,
    [shippingApi.reducerPath]: shippingApi.reducer,
    [productApi.reducerPath]: productApi.reducer,
    [orderApi.reducerPath]: orderApi.reducer,
    [reviewApi.reducerPath]: reviewApi.reducer,
    [creditSalesApi.reducerPath]: creditSalesApi.reducer,
    [guestOrderApi.reducerPath]: guestOrderApi.reducer,
    [guestUserOrderApi.reducerPath]: guestUserOrderApi.reducer,
    [userListApi.reducerPath]: userListApi.reducer,
    [flashSaleApi.reducerPath]: flashSaleApi.reducer,
    [bannerApi.reducerPath]: bannerApi.reducer,
    [subBannerApi.reducerPath]: subBannerApi.reducer,
    [dealOfTheDayApi.reducerPath]: dealOfTheDayApi.reducer,
    [bundleApi.reducerPath]: bundleApi.reducer,
    [deliveryAgentApi.reducerPath]: deliveryAgentApi.reducer,
    [warehouseApi.reducerPath]: warehouseApi.reducer,
    [warrantyApi.reducerPath]: warrantyApi.reducer,
    [productWarehouseApi.reducerPath]: productWarehouseApi.reducer,
    [couponApi.reducerPath]: couponApi.reducer,
    [rewardApi.reducerPath]: rewardApi.reducer,
    [rewardSettingsApi.reducerPath]: rewardSettingsApi.reducer,
    [adminRewardsApi.reducerPath]: adminRewardsApi.reducer,
    [adminCouponUsersApi.reducerPath]: adminCouponUsersApi.reducer,
    [dashboardApi.reducerPath]: dashboardApi.reducer,
    [smtpSettingsApi.reducerPath]: smtpSettingsApi.reducer,
    [deliverySettingsApi.reducerPath]: deliverySettingsApi.reducer,
    [registerAdminApi.reducerPath]: registerAdminApi.reducer,
    [roleMasterApi.reducerPath]: roleMasterApi.reducer,
    [roleMappingApi.reducerPath]: roleMappingApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      productsApi.middleware,
      categoryApi.middleware,
      subCategoryApi.middleware,
      unitApi.middleware,
      deliveryApi.middleware,
      shippingApi.middleware,
      productApi.middleware,
      orderApi.middleware,
      reviewApi.middleware,
      creditSalesApi.middleware,
      guestOrderApi.middleware,
      guestUserOrderApi.middleware,
      userListApi.middleware,
      flashSaleApi.middleware,
      bannerApi.middleware,
      subBannerApi.middleware,
      dealOfTheDayApi.middleware,
      bundleApi.middleware,
      deliveryAgentApi.middleware,
      warehouseApi.middleware,
      warrantyApi.middleware,
      productWarehouseApi.middleware,
      couponApi.middleware,
      rewardApi.middleware,
      rewardSettingsApi.middleware,
      adminRewardsApi.middleware,
      adminCouponUsersApi.middleware,
      dashboardApi.middleware,
      smtpSettingsApi.middleware,
      deliverySettingsApi.middleware,
      registerAdminApi.middleware,
      roleMasterApi.middleware,
      roleMappingApi.middleware,
    ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;